import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import App from './app/App';
import Locale from './common/Locale';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
ReactDOM.render(
  <Router>
    <Locale>
      <App/>
    </Locale>
  </Router>,
  document.getElementById('root')
);

registerServiceWorker();
